var map = {
	"./icons/map-marker.svg": "1a5b",
	"./icons/marker.svg": "4104",
	"./icons/marker_red.svg": "1dd2",
	"./images/marker.png": "53dc",
	"./images/marker2.png": "5be5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ef3";